import React, {Component} from 'react';
import {Platform, StyleSheet, Text, View, ScrollView, TouchableOpacity, ActivityIndicator, Image} from 'react-native';
import Colors from "../tools/Colors";
import {moderateScale} from "../tools/Scaling";
import HMImageView from "./HMImageView";
import HMTextView from "./HMTextView";
import PathFile from "../assets/PathFile";
import HMIcon from "./HMIcon";

export default class HMItemCategory extends Component {

    render() {
        let {typeUi, item, index, onPress, currentPage, selectTick} = this.props;

        //   let svg = (item.image && item.image.search('.svg') >= 0)
        let itemWidth = 400;
        selectTick = selectTick ? selectTick(index) : null;

        return (
            typeUi ?
                <TouchableOpacity
                    onPress={
                        () => {
                            onPress()
                        }
                    }
                    style={{
                        // width: "100%",

                        width: moderateScale(150),
                        //  flex:1,
                        height: itemWidth / 3 + moderateScale(10),
                        marginHorizontal: moderateScale(8),
                        marginBottom: moderateScale(12),
                        borderRadius: moderateScale(6),
                        //borderColor: '#d0d8df',
                        borderColor: Colors.colorPrimary,
                        backgroundColor: Colors.white,
                        borderWidth: moderateScale(2),
                        overflow: 'hidden'
                        //  marginVertical: moderateScale(2),
                        // padding: moderateScale(6)
                    }}>
                    <View
                        style={{
                            flex: .68,
                            width: itemWidth / 3 - moderateScale(10),
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>

                        <View
                            style={{
                                width: itemWidth / 7,
                                height: itemWidth / 7,
                            }}
                        >
                            {
                                item.svg ?

                                    <HMIcon

                                        //source={require('../../../../../assets/img/success.png')}
                                        //source={PathFile.image.background}
                                        //svg={PathFile.svg.add}
                                        type={"svg"}
                                        uri={item.svg}
                                        height={itemWidth / 7}
                                        width={itemWidth / 7}

                                        name={"add-circle-sharp"} style={{
                                        // fontSize: moderateScale(20),
                                        // color: Colors.blue,
                                        // marginHorizontal: moderateScale(4),
                                        marginRight: moderateScale(4),
                                        marginLeft: moderateScale(4),
                                        //  marginTop: moderateScale(3)
                                    }}/>
                                    :
                                    (item.image_source ?

                                            <HMImageView
                                                // resizeMode={FastImage.resizeMode.contain}
                                                resizeMode={"contain"}
                                                _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}
                                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                // uriComplete={item.image}
                                                source_image={item.image_source}
                                                styleText={{marginTop: moderateScale(10)}}
                                                borderRadius={4}/>
                                            :
                                            item.hasOwnProperty('image') && <HMImageView
                                                // resizeMode={FastImage.resizeMode.contain}
                                                resizeMode={"contain"}
                                                _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}

                                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                uriComplete={item.image}
                                                //source_image={item.image}
                                                styleText={{marginTop: moderateScale(10)}}
                                                borderRadius={4}/>
                                    )
                            }
                        </View>
                        {
                            item.count ?
                                <View
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        backgroundColor: Colors.red,
                                        height: moderateScale(30),
                                        width: moderateScale(30),
                                        borderRadius: moderateScale(15),
                                        margin: moderateScale(4),
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>

                                    <HMTextView
                                        numberOfLines={1}
                                        type={"bold"}
                                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                        text={item.count}

                                        style={{
                                            fontSize: moderateScale(10),

                                            color: Colors.white,


                                            //  textAlign: "right",
                                        }}/>

                                </View>
                                :
                                null
                        }
                    </View>


                    <HMTextView
                        numberOfLines={2}
                        type={"bold"}
                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                        text={item.name}
                        style={{
                            fontSize: moderateScale(13),

                            color: !selectTick ? Colors.colorPrimary : Colors.white,
                            marginTop: moderateScale(4),
                            textAlign: "center",
                        }}
                        styleRoot={{
                            flex: .32,
                            //backgroundColor: "#f4f4f4",
                            backgroundColor: selectTick ? Colors.colorPrimary : Colors.help,
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderTopColor: Colors.colorPrimary,
                            borderBottomColor: Colors.transparent,
                            borderRightColor: Colors.transparent,
                            borderLeftColor: Colors.transparent,
                            borderWidth: moderateScale(1.4),
                        }}

                    />

                    <View style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        //  alignItems: 'flex-end',
                        paddingHorizontal: moderateScale(2),
                    }}>
                        <Image
                            //  source={selectTick(index) ? PathFile.image.Check : null}
                            source={PathFile.image.Check}

                            //resizeMode="stretch"
                            style={[selectTick ? {} : {display: 'none'}, {

                                marginHorizontal: moderateScale(3),
                                width: moderateScale(24),
                                height: moderateScale(24),
                            }]}/>
                    </View>
                </TouchableOpacity>
                :
                <View
                    style={{
                        flex: 1,
                        marginHorizontal: moderateScale(4),
                        borderRadius: moderateScale(6),
                        minHeight: moderateScale(50),
                        //  borderColor: '#ddd',
                        //borderBottomWidth: 0,
                        shadowColor: !selectTick ? Colors.colorPrimary : Colors.transparent,
                        shadowOffset: {width: 0, height: moderateScale(.8)},
                        shadowOpacity: 0.6,
                        shadowRadius: moderateScale(2),
                        elevation: moderateScale(1),
                        marginEnd: moderateScale(20),
                        marginStart: moderateScale(20),
                        marginTop: moderateScale(4),
                        marginBottom: moderateScale(4),
                        backgroundColor: selectTick ? Colors.colorPrimary : Colors.help,
                        borderColor: !selectTick ? Colors.colorPrimary : Colors.transparent,
                        borderWidth: moderateScale(2),

                        overflow: 'hidden'

                    }}>
                    {/*      <Card>
                    <CardItem cardBody style={{
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingTop: 0,
                        paddingBottom: 0,
                    }}>*/}

                    <TouchableOpacity
                        style={{
                            //margin: 10,

                            flex: 1,
                            // height:100,
                            flexDirection: 'row',
                            // backgroundColor: '#ee6313',
                            alignItems: 'center'

                        }}
                        onPress={
                            () => {
                                onPress()
                            }
                        }
                    >

                        <View
                            style={{
                                flexDirection: 'row',
                                flex: .9,
                                alignItems: 'center',
                            }}>
                            {
                                item.hasOwnProperty('image') &&
                                <View
                                    style={{


                                        width: moderateScale(70),

                                        height: moderateScale(60),
                                        padding: moderateScale(3),
                                        borderEndWidth: moderateScale(1),
                                        borderEndColor:!selectTick ? Colors.helpBorder: Colors.white,
                                        paddingHorizontal:moderateScale(10),

                                        //     backgroundColor: '#ee5d00'
                                    }}>
                                    {/*
                                                        <SvgUri

                                                            width="100%"
                                                           // uri={item.image}
                                                            uri="http://portal.arak.ir/storage/2019/gangster.svg"

                                                            height="100%"

                                                        />*/}
                                    {/*  <HMSvgView
                                                                    //uriComplete={"https://image.flaticon.com/icons/svg/2297/2297971.svg"}
                                                                    //  uriComplete={item.image}
                                                                       uriComplete={"https://image.flaticon.com/icons/svg/2626/2626047.svg"}
                                                                    indexParent={currentPage}
                                                                />*/}

                                    {
                                        //svg ?
                                        // null
                                        // //
                                        // // {/*<HMSvgView*/}
                                        // //     {/*//  uriComplete={"https://image.flaticon.com/icons/svg/2297/2297971.svg"}*/}
                                        // //      {/*uriComplete={item.image}*/}
                                        // //    {/*// uriComplete={item.image.replace(new RegExp('56.50', "g"), '56.52')}*/}
                                        // //     {/*//  uriComplete={"https://image.flaticon.com/icons/svg/2626/2626047.svg"}*/}
                                        // //     {/*indexParent={currentPage}*/}
                                        // // {/*/>*/}
                                        // //
                                        //
                                        // :
                                        // <HMImageView
                                        //     //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                        //     uriComplete={item.image}
                                        //     //uriComplete={item.image.replace(new RegExp('56.50', "g"), '56.52')}
                                        //     //    uriComplete={item.svg}
                                        //     indexParent={currentPage}
                                        // />
                                    }
                                    {item.image && item.image.length > 0 ?

                                        <HMImageView
                                            _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}

                                            //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                            uriComplete={item.image}
                                            //uriComplete={item.image.replace(new RegExp('56.50', "g"), '56.52')}
                                            //    uriComplete={item.svg}
                                            indexParent={currentPage}

                                        />
                                        :
                                        null
                                    }
                                </View>
                            }

                            <View style={{width: moderateScale(6)}}/>

                                <HMTextView
                                    numberOfLines={1}
                                     type={'bold'}
                                    text={item.name ? item.name : item.subjects_tks_subject}
                                    style={{
                                        color: selectTick ? Colors.white : Colors.blackLight,
                                        // marginEnd: moderateScale(10),
                                        fontSize: moderateScale(13),


                                    }}
                                    styleRoot={{flex: 1, flexDirection: 'row',}}

                                />

                        </View>

                        <View style={{flex: .1, alignItems: 'flex-end', paddingHorizontal: moderateScale(10),}}>
                            <Image
                                //  source={selectTick(index) ? PathFile.image.Check : null}
                                source={PathFile.image.Check}

                                //resizeMode="stretch"
                                style={[selectTick ? {} : {display: 'none'}, {

                                    marginHorizontal: moderateScale(3),
                                    width: moderateScale(24),
                                    height: moderateScale(24),
                                }]}/>
                        </View>
                    </TouchableOpacity>
                    {/*          </CardItem>
                </Card>*/}
                </View>

        )

    }

}
